import {
  UserHistoryItem, BookingPoliciesResponse, ReservationType
} from '@user-history/entities/user-history-item';
import { HistoryBookingDetail } from '@user-history/entities/history-booking-detail';
import { CancellationSuccessType } from '@user-history/entities/cancellation.response';
import { UserHistoryOptions } from '@user-history/entities/user-history-options';

export const userHistoryFeatureName = 'userHistoryModuleState';

export type UiUserHistorysState = Readonly<{
  isLoadingUserHistory: boolean,
  isLoadingDetailHistory: boolean,
  isLoadingBookingPolicies: boolean,
  errorFlightChanges: boolean,
  successFlightChanges: boolean,
  historyDetailType: ReservationType,
  UiTabSelected: UserHistoryOptions,
  isLoadingCancellation: boolean,
  loadedList: boolean,
  resendingVoucher: boolean,
  dependenciesHaveBeenLoaded: boolean,
  historyDetailTitle: string,
}>;

export type UserHistoryModuleState = Readonly<{
  userHistoryList: UserHistoryItem[],
  historyBookingDetail: HistoryBookingDetail,
  bookingPolicies: BookingPoliciesResponse,
  cancellationSuccess: CancellationSuccessType,
  ui: UiUserHistorysState,
}>;
